import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";
import {allSchoolClasses} from "../../data/Enums";

const SchoolThemesItemBrowserHeader = ({
                                             schoolClassId,
                                             setSchoolClassId,
                                             schoolSubjectId,
                                             setSchoolSubjectId,
                                             ...restProps
                                         }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSimpleSelect
                    label="Класс"
                    options={schoolClassOptions}
                    value={schoolClassId}
                    setValue={setSchoolClassId}
                />
                <ItemBrowserHeaderSelect
                    label="Предмет"
                    selectedId={schoolSubjectId}
                    setSelectedId={setSchoolSubjectId}
                    apiName2="school_subjects"
                    specialOptions={[{id: 0, name: "(все)"}]}
                    showIds={true}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const schoolClassOptions = [{id: 0, name: "(все)"}, ...allSchoolClasses];

export default SchoolThemesItemBrowserHeader;